<!--Translated-->
<template>
  <tbody>
    <template v-for="(item, index) in displayItems">
      <tr
        class="row tbl_row--active"
        v-if="item.type === 'product'"
        :key="item.data.id"
      >
        <td
          class="tbl-cellproblem"
          v-if="index === 0"
          :rowspan="totalRowsCount"
        >
          <div class="cellproblem-inner">
            <div class="tbl_info">
              <div class="tbl_info-wrap">
                <div v-svg="{ name: 'info' }"></div>
                <HoverTooltip :header="sType.name" :text="sType.description" />
              </div>
              <div class="tbl_info-celltext">{{ sType.name }}</div>
            </div>
            <Button
              v-if="products.length >= 2 && canEdit"
              :text="$t('DefenseCombinations:Button')"
              size="h-micro"
              color="accentlines"
              icon="plus"
              @click="addCombination"
            />
          </div>
        </td>

        <td
          class="tbl-cellproduct"
          colspan="3"
          :class="{ 'tbl-cellproduct--grey': !productsAsMap[item.data.id] }"
        >
          <div class="tbl_info">
            <div class="tbl_info-wrap">
              <div
                v-if="item.data.is_active"
                v-svg="{ name: 'info' }"
                :key="'active'"
              />
              <div
                v-else
                v-svg="{ name: 'warningtriangle' }"
                :key="'no_active'"
                id="force-red"
              />
              <HoverTooltipProduct :product="item.data" />
            </div>
            <div class="tbl_info-celltext">{{ item.data.name }}</div>
          </div>
        </td>
        <td class="tbl-cellinpt">
          <InputNumber
            class="inputintable"
            label="-"
            :value="productsAsMap[item.data.id]"
            @input="onInput(item.data, $event)"
            :state="isSaving ? 'disabled' : readonly ? 'disabled2' : ''"
          />
        </td>
        <td class="tbl-cellprice">
          {{
            item.data.picking
              ? (
                  (item.data.price / item.data.picking) *
                  productsAsMap[item.data.id]
                ).toFixed(2)
              : '0.00'
          }}
        </td>
      </tr>

      <template v-else-if="item.type === 'combination'">
        <tr
          v-if="index > 0"
          class="row row--combination-spacer"
          :key="'combo-spacer-' + item.id"
        >
          <td colspan="5"></td>
        </tr>

        <tr
          class="row tbl_row--active row--combination"
          :key="'combo-header-' + item.id"
        >
          <th
            v-if="index === 0"
            class="tbl-cellproblem"
            :rowspan="totalRowsCount"
          >
            <div class="cellproblem-inner">
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div v-svg="{ name: 'info' }"></div>
                  <HoverTooltip
                    :header="sType.name"
                    :text="sType.description"
                  />
                </div>
                <div class="tbl_info-celltext">{{ sType.name }}</div>
              </div>
              <Button
                v-if="products.length >= 2 && canEdit"
                :text="$t('DefenseCombinations:Button')"
                size="h-micro"
                color="accentlines"
                icon="plus"
                @click="addCombination"
              />
            </div>
          </th>
          <th class="combination-header-cell" colspan="4">
            <div class="tbl_info">
              <div class="tbl_info-wrap">
                <div v-svg="{ name: 'combinationpuzzle' }"></div>
                <AppInput
                  :value="item.comment"
                  @input="updateComboComment(item.id, $event)"
                  class="inputintable inputintable--comment"
                  type="text"
                  :placeholder="$t('DefenseCombinations:CommentPlaceholder')"
                />
              </div>
            </div>
          </th>
          <th
            class="col-delete col-delete--btn unicol-colordark"
            @click="removeCombination(item.id)"
          >
            <div v-svg="{ name: 'delete' }"></div>
          </th>
        </tr>

        <tr
          v-for="(comboProd, cIdx) in item.products"
          :key="'combo-prod-' + comboProd._comboProductId"
          class="row tbl_row--active row--combination"
        >
          <td
            v-if="cIdx === 0"
            class="col-add"
            :rowspan="item.products.length"
            @click="openComboAddModal(item.id)"
          >
            <div v-svg="{ name: 'plus2' }"></div>
          </td>
          <td
            class="tbl-cellproduct"
            :class="{ 'tbl-cellproduct--grey': !comboProd.quantity }"
          >
            <div class="tbl_info">
              <div class="tbl_info-wrap">
                <div
                  v-if="comboProd.is_active"
                  v-svg="{ name: 'info' }"
                  :key="'active'"
                />
                <div
                  v-else
                  v-svg="{ name: 'warningtriangle' }"
                  :key="'no_active'"
                  id="force-red"
                />
                <HoverTooltipProduct :product="comboProd" />
              </div>
              <div class="tbl_info-celltext">{{ comboProd.name }}</div>
            </div>
          </td>
          <td
            class="col-delete"
            @click="removeComboProduct(comboProd._comboProductId)"
            style="cursor: pointer"
          >
            <div v-svg="{ name: 'delete' }"></div>
          </td>
          <td class="tbl-cellinpt">
            <InputNumber
              class="inputintable"
              type="number"
              label="-"
              :value="comboProd.quantity"
              @input="
                updateComboProductQuantity(comboProd._comboProductId, $event)
              "
            />
          </td>
          <td class="tbl-cellprice">
            {{
              comboProd.picking && comboProd.quantity
                ? (
                    (comboProd.price / comboProd.picking) *
                    comboProd.quantity
                  ).toFixed(2)
                : '0.00'
            }}
          </td>
        </tr>
        <tr
          v-if="item.products.length === 0"
          class="row tbl_row--active"
          :key="'combo-empty-' + item.id"
        >
          <td
            class="col-add combination-col-add"
            @click="openComboAddModal(item.id)"
          >
            <div v-svg="{ name: 'plus2' }"></div>
          </td>
          <td
            class="tbl-cellproduct"
            colspan="4"
            style="text-align: center; color: #999"
          >
            {{ $t('DefenseCombinations:MinProducts') }}
          </td>
        </tr>
      </template>
    </template>

    <tr
      class="row tbl_row--active"
      v-if="products.length === 0 && combinations.length === 0"
    >
      <td class="tbl-cellproblem" rowspan="1">
        <div class="tbl_info">
          <div class="tbl_info-wrap">
            <div v-svg="{ name: 'info' }"></div>
            <HoverTooltip :header="sType.name" :text="sType.description" />
          </div>
          <div class="tbl_info-celltext">{{ sType.name }}</div>
        </div>
      </td>
      <td class="tbl-cellproduct" colspan="5" style="text-align: center">
        {{ $t('TemplateRowStimulationType:NoProducts') }}
      </td>
    </tr>

    <tr class="tablelinedecor">
      <td colspan="6"></td>
    </tr>

    <DefenseAddProductModal
      v-if="showAddModal"
      :productsList="availableProductsToAdd"
      :alreadyAdded="alreadyAddedProductsIds"
      @save="addProduct"
      @close="
        showAddModal = false;
        activeCombinationId = null;
      "
    />
  </tbody>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import { mutationTypes } from '@/store/modules/plantsCare';
import InputNumber from '@/components/views/wrappers/InputNumberWithCast';
import Button from '@/components/views/Button';
import HoverTooltip from './HoverTooltip';
import HoverTooltipProduct from './HoverTooltipProduct';
import DefenseAddProductModal from './DefenseAddProductModal';
import AppInput from '@/components/views/Input.vue';

export default {
  name: 'TemplateRowStimulationType',
  props: {
    phase: { type: Object, required: true },
    sType: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
  },
  components: {
    InputNumber,
    HoverTooltip,
    HoverTooltipProduct,
    Button,
    DefenseAddProductModal,
    AppInput,
  },
  data() {
    return {
      showAddModal: false,
      activeCombinationId: null,
    };
  },
  computed: {
    ...mapGetters(['plantsCareProductsAsMap', 'plantsCareSTypesProductsAsMap']),
    ...mapState({
      canEdit: (state) =>
        state.auth.currentUserRole?.claim_plants_care_add === 1,
      isSaving: (state) => state.plantsCare.isSaving,
      products(state) {
        return state.plantsCare.productsTypesStimulation
          .filter(
            ({ type_stimulation_id }) => type_stimulation_id === this.sType.id
          )
          .map(({ product_id }) => this.plantsCareProductsAsMap[product_id])
          .filter(Boolean)
          .filter(
            (product) =>
              product.is_active ||
              state.plantsCare.templateTypesStimulationProducts.some(
                ({ product_id }) => product_id === product.id
              )
          );
      },
    }),
    productsAsMap() {
      const getValueById = (id) =>
        this.plantsCareSTypesProductsAsMap[
          `phase_${this.phase.id}_stype_${this.sType.id}_product_${id}`
        ]?.quantity ?? '';
      return Object.fromEntries(
        this.products.map((p) => [p.id, getValueById(p.id)])
      );
    },
    combinations() {
      const combos =
        this.$store.state.plantsCare.templateTypesStimulationCombinations.filter(
          (c) =>
            c.phase_id === this.phase.id &&
            c.type_stimulation_id === this.sType.id
        );
      const comboProducts =
        this.$store.state.plantsCare
          .templateTypesStimulationCombinationsProducts;
      return combos.map((c) => ({
        type: 'combination',
        id: c.id,
        comment: c.comment,
        products: comboProducts
          .filter((p) => p.combination_id === c.id)
          .map((p) => ({
            ...p,
            ...(this.plantsCareProductsAsMap[p.product_id] || {}),
            _comboProductId: p.id,
          })),
      }));
    },
    displayItems() {
      const items = [];
      this.products.forEach((p) => {
        items.push({ type: 'product', data: p });
      });
      this.combinations.forEach((combo) => {
        items.push(combo);
      });
      return items;
    },
    totalRowsCount() {
      return (
        this.displayItems.reduce((acc, item, index) => {
          if (item.type === 'combination') {
            const rowsForProducts =
              item.products.length > 0 ? item.products.length : 1;
            const spacerRow = index > 0 ? 1 : 0;
            return acc + spacerRow + 1 + rowsForProducts;
          }
          return acc + 1;
        }, 0) || 1
      );
    },
    alreadyAddedProductsIds() {
      if (this.activeCombinationId) {
        const combo = this.combinations.find(
          (c) => c.id === this.activeCombinationId
        );
        return combo ? combo.products.map((p) => p.product_id) : [];
      }
      return [];
    },
    availableProductsToAdd() {
      return this.products;
    },
  },
  methods: {
    confirmDelete(message, next) {
      this.$confirm({
        message,
        buttons: {
          left: {
            text: this.$t('DefenseCombinations:ConfirmDelete'),
            icon: 'delete',
          },
          right: {
            text: this.$t('DefenseCombinations:ConfirmCancel'),
            icon: 'cancel',
          },
        },
        callback: (confirm) => {
          if (confirm) next();
        },
      });
    },
    openComboAddModal(id) {
      this.activeCombinationId = id;
      this.showAddModal = true;
    },
    addCombination() {
      this.$store.commit(mutationTypes.addStimulationCombination, {
        phase_id: this.phase.id,
        type_stimulation_id: this.sType.id,
      });
    },
    removeCombination(id) {
      const combo = this.combinations.find((c) => c.id === id);
      const doRemove = () =>
        this.$store.commit(mutationTypes.removeStimulationCombination, { id });

      if ((combo?.products?.length ?? 0) > 0) {
        this.confirmDelete(
          this.$t('DefenseCombinations:ConfirmDeleteCombination'),
          doRemove
        );
        return;
      }

      doRemove();
    },
    removeComboProduct(comboProductId) {
      const comboProduct = this.combinations
        .flatMap((c) => c.products || [])
        .find((p) => p._comboProductId === comboProductId);
      const doRemove = () =>
        this.$store.commit(mutationTypes.removeStimulationCombinationProduct, {
          id: comboProductId,
        });

      if ((comboProduct?.quantity ?? 0) > 0) {
        this.confirmDelete(
          this.$t('DefenseCombinations:ConfirmDeleteProduct'),
          doRemove
        );
        return;
      }

      doRemove();
    },
    addProduct(productId) {
      if (this.activeCombinationId) {
        this.$store.commit(mutationTypes.addStimulationCombinationProduct, {
          combination_id: this.activeCombinationId,
          product_id: productId,
        });
        this.activeCombinationId = null;
      } else {
        this.$store.commit(mutationTypes.upsertStimulationType, {
          phase_id: this.phase.id,
          type_stimulation_id: this.sType.id,
          product_id: productId,
          quantity: 0,
        });
      }
    },
    onInput(product, value) {
      this.$store.commit(mutationTypes.upsertStimulationType, {
        phase_id: this.phase.id,
        type_stimulation_id: this.sType.id,
        product_id: product.id,
        quantity: value,
      });
    },
    updateComboComment(id, comment) {
      this.$store.commit(mutationTypes.updateStimulationCombinationComment, {
        id,
        comment,
      });
    },
    updateComboProductQuantity(id, quantity) {
      this.$store.commit(
        mutationTypes.upsertStimulationCombinationProductQuantity,
        { id, quantity }
      );
    },
  },
};
</script>
